<!-- asw-payment-detail-modal -->
<div
  #modalContents
  class="l-modal02__contents u-modal-size-pc-1000 js-modal-contents"
  aria-modal="true"
  [id]="modalId + '-PaymentDetailModal'"
  [attr.aria-labelledby]="'label.paymentDetail' | staticMsg"
  role="dialog"
>
  <div #modalHead [class]="lmodalHeaderClass">
    <!-- モーダルヘッダーが入ります -->
    <div class="p-modal-head07">
      <h1 id="modalTitle" class="p-modal-head02__title">{{ 'label.servicePaymentDetail' | staticMsg }}</h1>
      <button id="payment-detail-btn" class="p-modal-head02__close js-modal-close" (click)="closeEventHandler()">
        <span class="u-visually-hidden" [innerHTML]="'label.viewDetails.close' | staticMsg"></span>
      </button>
    </div>
    <!-- //モーダルヘッダーが入ります -->
  </div>
  <div #modalBody [class]="lmodalBodyClass">
    <div class="l-modal02__body l-modal02__body--bg-gray5 js-modal-body">
      <!-- モーダルの中身が入ります -->
      <ng-container [ngSwitch]="modalId">
        <asw-payment-detail-s02-p020 *ngSwitchCase="modalIdS02P020"></asw-payment-detail-s02-p020>
        <asw-payment-detail-s01-p031
          *ngSwitchDefault="modalIdS01P031"
          [data]="payload.data.orderData"
        ></asw-payment-detail-s01-p031>
      </ng-container>
      <!-- //モーダルの中身が入ります -->
    </div>
  </div>
</div>
